import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/common/hooks/useIsMobile";
import { RouterPath } from "@/router/types";
import { MainButton } from "@/shared/ui/Buttons/MainButton";
import { TagsList } from "@/shared/ui/TagsList";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_LIGHT, LIGHT_COLOR } from "@/styles/colorsJS";

const bullets = [
  <FormattedMessage key="1" defaultMessage="Онлайн-подписание облачной ЭЦП" />,
  <FormattedMessage key="2" defaultMessage="Проверки по госбазам и КБ" />,
  <FormattedMessage key="3" defaultMessage="Уведомление работодателя" />,
  <FormattedMessage key="4" defaultMessage="Подтверждение через OTP" />,
];

export function Banner() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const imageSrc = isMobile
    ? "/static/images/home-banner-top.webp"
    : "/static/images/home-banner-top-desktop.webp";

  return (
    <section className="bg-[linear-gradient(270deg,_#00A960_0%,_#00D478_50%,_#00A960_100%)]">
      <div className="lgc:relative lgc:flex container">
        <div className="lgc:max-w-[var(--column-max)] lgc:px-0 lgc:py-0 lgc:mt-[var(--landing-section-gap)] px-4 pt-6">
          <Typography as="h1" type="h1" color={LIGHT_COLOR}>
            <FormattedMessage defaultMessage="Факторинг заработной платы для сотрудников" />
          </Typography>
          <Typography
            as="p"
            type="title"
            weight="semiBold"
            color={BRAND_LIGHT}
            className="pt-4"
          >
            <FormattedMessage
              defaultMessage="Прозрачный финансовый инструмент: уступайте право требования части
            зарплаты и получайте финансирование онлайн — быстро и безопасно"
            />
          </Typography>
          <MainButton
            id="home-top-banner-application"
            className="lgc:mt-10 mt-6"
            onClick={() => navigate(RouterPath.Cabinet)}
            secondary
          >
            <FormattedMessage defaultMessage="Подать заявку" />
          </MainButton>
        </div>
        <div className="lgc:static relative">
          <TagsList
            className="lgc:px-0 lgc:py-10 absolute right-0 bottom-0 left-0 px-4 py-6"
            textList={bullets}
          />
          <img src={imageSrc} alt="factor+" />
        </div>
      </div>
    </section>
  );
}
